"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGButton = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Button.scss");

var APPEARANCES = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  tertiary: 'btn-tertiary',
  primaryOutline: 'btn-outline-primary',
  secondaryOutline: 'btn-outline-secondary',
  link: 'btn-link'
};
var SIZES = {
  small: 's-s',
  normal: 's-n',
  large: 's-l'
};

var BHGButton = function BHGButton(props) {
  var appearance = props.appearance,
      size = props.size,
      className = props.className,
      children = props.children,
      disabled = props.disabled,
      loading = props.loading,
      loadingText = props.loadingText,
      ButtonWrapper = props.ButtonWrapper,
      onClick = props.onClick;

  var TheButton = /*#__PURE__*/_react.default.createElement("button", {
    className: 'bhg-btn btn ' + APPEARANCES[appearance] + ' ' + SIZES[size] + (className ? " " + className : ""),
    disabled: disabled || loading,
    "aria-disabled": disabled || loading,
    onClick: onClick
  }, loading ? loadingText : children);

  return ButtonWrapper ? /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    disabled: disabled || loading
  }, TheButton) : TheButton;
};

exports.BHGButton = BHGButton;
BHGButton.defaultProps = {
  loading: false,
  loadingText: 'Loading...',
  appearance: 'primary',
  disabled: false,
  size: 'normal',
  onClick: null
};